import React, { useEffect, useState } from "react";

// This file is used to generate the pricing table on the Squarespace marketing page
// Its done here because it is 1000% easier to do it in React than in Squarespace
//
// To use this file, open the http://localhost:3000/welcome/pricingPlans page and copy the contents of the dom node with id="SquareSpaceCodeBlock"
// Paste the contents into any old html formmating tool.
// Copy the formatted html and paste it into the Squarespace code block

import {
  CountryPlans,
  FeatureRow,
  FeatureSection,
  AddOnSection,
  AddOnFeatureRow,
  nzPlans,
  auPlans,
  tongaPlans,
  ukPlans,
} from "./features";
import { Link, Routes } from "react-router-dom-v5-compat";
export const NZPricingPlans = () => <PricingPlans countryPlans={nzPlans} />;
export const AuPricingPlans = () => <PricingPlans countryPlans={auPlans} />;
export const UkPricingPlans = () => <PricingPlans countryPlans={ukPlans} />;
export const TongaPricingPlans = () => (
  <PricingPlans countryPlans={tongaPlans} />
);

export const PricingPlanIndex = () => {
  return (
    <div>
      <Link to="nz">NZ</Link> <Link to="au">Au</Link> <Link to="uk">Uk </Link>{" "}
      <Link to="to">Tonga</Link>{" "}
    </div>
  );
};
export const PricingPlans = ({
  countryPlans,
}: {
  countryPlans: CountryPlans;
}) => {
  return (
    <div id="SquareSpaceCodeBlock">
      {countryPlans.featureSections.map((section: FeatureSection, index) => (
        <div key={index}>
          {section.title && (
            <div className="featureSectionTitle">{section.title}</div>
          )}
          <table className="featureTable">
            <thead>
              <tr>
                <th>Feature</th>
                <th>{countryPlans.small} </th>
                <th>{countryPlans.medium} </th>
                <th>{countryPlans.large} </th>
              </tr>
            </thead>
            <tbody>
              <>
                {section.features.map((feature: FeatureRow) => (
                  <tr key={feature.feature}>
                    <td>{feature.feature}</td>
                    <td>{feature.small}</td>
                    <td>{feature.medium}</td>
                    <td>{feature.large}</td>
                  </tr>
                ))}
              </>
            </tbody>
          </table>
        </div>
      ))}
      {countryPlans.addonSections.map((section: AddOnSection, index) => (
        <div>
          <div className="featureSectionTitle">
            {index == 0 && <div className="ourAddOns">Our Add Ons</div>}
            {section.title}
          </div>
          <table className="featureTable">
            <thead>
              <tr>
                <th>Feature</th>
                <th>{countryPlans.sogui} </th>
                <th>{countryPlans.paperless} </th>
                <th>{countryPlans.regulr} </th>
              </tr>
            </thead>
            <tbody>
              <>
                {section.features.map((feature: AddOnFeatureRow) => (
                  <tr key={feature.feature}>
                    <td>{feature.feature}</td>
                    <td>{feature.sogui}</td>
                    <td>{feature.paperless}</td>
                    <td>{feature.regulr}</td>
                  </tr>
                ))}
              </>
            </tbody>
          </table>
        </div>
      ))}
      <style>
        {`
.featureTable {
  width: 100%
}
.featureTable thead tr th:first-child {
  text-align: left
}
.featureTable tr td:first-child {
  text-align: left;

}
.featureTable tr td {
  font-size: 14px;
  text-align: center;
  padding: 4px 12px;
}
.featureTable th {
  background: #E9F8FF;
  padding: 6px 12px;
}

 .featureTable td{
  border: solid 1px  #D1D5DB;
  width: 20%;
}
.featureTable td:first-child{
  border-left: none;
  width: 40%;
}
.featureTable td:last-child{
  border-right: none;
}
.featureSectionTitle {
  font-size: 24px;
  padding: 64px 12px 12px;
}
.ourAddOns {
  font-size: 18px;
  font-weight: bold;

}

`}
      </style>
    </div>
  );
};
